import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { container } from "setup/dependency/inversify.config";
import * as auth from "app/modules/auth/redux/AuthRedux";
import { IAuthenticationService } from "services/AuthenticationService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

const ExternalAccessLinkHandler: React.FC = () => {
  const authService = container.get<IAuthenticationService>(SERVICE_TYPES.AuthenticationService);
  const { token } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // External access tokens live in sessionStorage, separate from a normal login's localStorage
  // tokens, so there's no need to log out of a normal session first — doing so would also clear
  // that normal session in any other open tab.
  const verifyExternalAccessUserFromToken = useCallback(async () => {
    try {
      const tokens = await authService.verifyExternalAccessUserFromToken(token!);
      dispatch(
        auth.actions.setExternalAccessTokens({
          singleUseToken: token!,
          externalAccessToken: tokens.token!,
          accessPath: tokens.accessPath!,
        })
      );
      navigate(`/${tokens.accessPath}`);
    } catch (error) {
      console.error(error);
      toast.error("Invalid link. This may mean the link has expired or has already been used.");
      navigate("/auth");
    }
  }, [authService, dispatch, navigate, token]);

  useEffect(() => {
    const handleExternalAccessLink = async () => {
      if (token !== undefined) {
        await verifyExternalAccessUserFromToken();
      } else {
        navigate("/auth");
      }
    };

    handleExternalAccessLink();
  }, [navigate, token, verifyExternalAccessUserFromToken]);

  return <></>;
};

export default ExternalAccessLinkHandler;
